// extracted by mini-css-extract-plugin
export default {"card":"ScoreCard-module__card__vZn8b","content":"ScoreCard-module__content__D09+q","score":"ScoreCard-module__score__2Rkmk","average":"ScoreCard-module__average__uAvfD"};